// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__sqNq0","container":"Profile_container__eeqC7"};